import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../img/Logo_W.png';
import { useState } from 'react';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="logo-area">
        <Link to="/">
          <img src={logo} alt="Company Logo" className="logo" />      
        </Link>
      </div>

      <div className={`menu-toggle ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
        <span></span><span></span><span></span>
      </div>

      <nav className={`menu-area ${menuOpen ? 'show' : ''}`}>
        <Link to="/" onClick={() => setMenuOpen(false)}>홈</Link>
        <Link to="/about" onClick={() => setMenuOpen(false)}>회사소개</Link>
        <Link to="/services" onClick={() => setMenuOpen(false)}>제품/서비스</Link>
      </nav>
    </header>
  );
}

export default Header;
